export default __webpack_public_path__ + "static/media/gaming.0b1da681.svg";